import { useContext, useEffect } from 'react';
import { StickySearchContext } from '@/Search/components/StickySearchProvider';
import KeywordSearch from '@/SearchHeader/KeywordSearch';
import { usePagination } from '@/SearchResults/hooks';
import TitleTag from '@/SEO/TitleTag';
import { useScreenSize } from '~/contexts/DeviceContext';
import { Header, StickyWrapper } from './SearchHeader.styles';

export default function SearchHeader() {
  const { width } = useScreenSize();
  const {
    pagination: { totalMatchedInventory = 0 }
  } = usePagination();
  const { isStickySearchBar, observe, disconnect } =
    useContext(StickySearchContext);

  useEffect(() => {
    observe('#search-tools');

    return () => {
      disconnect();
    };
  }, [disconnect, observe, width]);

  return (
    <StickyWrapper
      className={isStickySearchBar ? 'is-sticky' : undefined}
      id="search-wrapper"
    >
      <Header className={isStickySearchBar ? 'is-sticky' : undefined}>
        <TitleTag />
        <p className="m-0 t-body-xs" data-qa="results-count">
          {totalMatchedInventory.toLocaleString()} results
        </p>
      </Header>
      <KeywordSearch isStickySearchBar={isStickySearchBar} />
    </StickyWrapper>
  );
}
